<div class="ud-dialog">
  <div class="ud-header">
    <div class="ud-title-wrap">
      <div class="ud-title-icon"><mat-icon>outgoing_mail</mat-icon></div>
      <div><h2 class="ud-title">Invite to another company</h2><div class="ud-subtitle">Give this user access to another workspace</div></div>
    </div>
    <button mat-icon-button mat-dialog-close class="ud-close" [disabled]="submitted" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>
  <form id="inviteOtherCompany" class="ud-body" (ngSubmit)="invite()">
    <div class="ud-context"><mat-icon>person_outline</mat-icon><span>{{ user?.displayName || user?.emailAddress }}</span></div>
    <div class="ud-field">
      <label class="ud-label">Company <span class="ud-required">*</span></label>
      <mat-form-field appearance="outline" class="ud-mat">
        <mat-select [(ngModel)]="selectedCompanyId" name="company" placeholder="Choose a company">
          @for (c of companies; track c.uid) { <mat-option [value]="c.uid">{{c.name}}</mat-option> }
        </mat-select>
        @if (gettingCompanies) { <mat-spinner matSuffix diameter="20" strokeWidth="3"></mat-spinner> }
      </mat-form-field>
      <p class="ud-help">The user will receive an invitation for the selected company.</p>
    </div>
  </form>
  <div class="ud-footer">
    <button mat-button mat-dialog-close class="ud-btn-ghost" [disabled]="submitted">Cancel</button>
    <button type="submit" form="inviteOtherCompany" class="ud-btn-primary" [disabled]="submitted || !selectedCompanyId">
      @if (submitted) { <mat-spinner diameter="20" strokeWidth="3"></mat-spinner> } @else { <span>Send invitation</span><mat-icon>send</mat-icon> }
    </button>
  </div>
</div>
